import React from 'react'
import { Row, Col } from 'antd'
import './top-cost-usage.scss'


export default ( {title, usageTypes} ) => (
    <div>
        <Row className="top-cost-container">
            <Col span={24}>
                <Row type='flex' gutter={5}>
                    <Col span={24}>
                        <h2>{title}</h2>
                    </Col>
                </Row>
                <Row type='flex' gutter={5} style={{marginTop:10}}>
                    <Col span={24}>
                        <div className='transfer-list'>
                            {usageTypes && usageTypes.map((usageType,i) => <UsageType key={i} usageType={usageType} />)}
                        </div>
                    </Col>
                </Row>
                
            </Col>
        </Row>
    </div>
)


const UsageType = ({ usageType }) => (
    <div className='row'>
      <p className='description'>{usageType[0]}</p>      
      <p className='cost'><b>$</b>{usageType[1]}</p>
    </div>
  )


  
  